import React from 'react';
import Reveal from './Reveal';
import { bandMembers } from '../mock';

const splitName = (full) => {
  const parts = full.trim().split(/\s+/);
  return { first: parts[0], last: parts.slice(1).join(' ') };
};

// Splits "as Stevie Nicks" -> { lead: "as Stevie", tail: "Nicks" }
const splitAs = (asLine) => {
  const parts = asLine.trim().split(/\s+/);
  if (parts.length <= 2) return { lead: parts.join(' '), tail: '' };
  return {
    lead: `${parts[0]} ${parts[1]}`,
    tail: parts.slice(2).join(' '),
  };
};

const Band = () => {
  return (
    <section id="band" className="py-24 md:py-32 bg-[#efe6d8]/40">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <Reveal className="text-center mb-16">
          <p className="text-[#e6396b] tracking-[0.4em] text-[12px] font-semibold mb-5">
            THE BAND
          </p>
          <h2 className="font-serif text-[44px] md:text-[64px] text-[#1a1a1a] font-medium">
            Meet The Band
          </h2>
          <p className="mt-5 text-[16px] md:text-[17px] text-[#6a6a6a] max-w-xl mx-auto leading-relaxed">
            Five brilliant musicians delivering an authentic, high-energy
            tribute night you won't forget.
          </p>
        </Reveal>

        <div className="flex flex-wrap justify-center gap-6">
          {bandMembers.map((m, i) => {
            const { first, last } = splitName(m.name);
            const { lead, tail } = splitAs(m.as);

            return (
              <Reveal
                key={m.name}
                delay={i * 80}
                className="w-[calc(50%-12px)] md:w-[calc(33.333%-16px)] lg:w-[calc(20%-19.2px)]"
              >
                <div className="group relative bg-white rounded-xl overflow-hidden shadow-sm hover:shadow-2xl transition-all duration-500 hover:-translate-y-2">
                  <div className="relative overflow-hidden aspect-[4/4.2]">
                    <img
                      src={m.image}
                      alt={`${m.name} - ${m.as}`}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                    />
                  </div>
                  <div className="p-5 text-center">
                    {/* Real name: split first / last on mobile, single line on md+ */}
                    <h3 className="font-serif text-[20px] md:text-[22px] text-[#1a1a1a] font-medium leading-tight">
                      <span className="block md:hidden">
                        {first}
                        <br />
                        {last}
                      </span>
                      <span className="hidden md:block">{m.name}</span>
                    </h3>

                    <p className="text-[13px] text-[#6a6a6a] mt-1.5">
                      {m.role}
                    </p>

                    {/* "as X" badge: split on mobile, single line on md+ */}
                    <span
                      className="inline-block mt-3 text-[12px] text-[#e6396b] border border-[#e6396b]/40 rounded-2xl px-3 py-1 bg-[#e6396b]/5 leading-tight"
                    >
                      <span className="block md:hidden">
                        {lead}
                        {tail && (
                          <>
                            <br />
                            {tail}
                          </>
                        )}
                      </span>
                      <span className="hidden md:inline whitespace-nowrap">
                        {m.as}
                      </span>
                    </span>
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Band;
